import React from 'react'
import heroimg from '../../Assets/homeimgs/homeimg.jpg'
const HeroSection2 = () => {
    return (
        <React.Fragment>
            <div
                className="h-[60vh] md:h-[75vh] lg:h-[85vh] flex items-center justify-center"
                style={{
                    backgroundImage: `url(${heroimg})`,
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                    backgroundPosition: "right",
                }}
            >
                <div className="text-center text-white max-w-[90%] sm:max-w-[80%] md:max-w-[70%] space-y-4 md:space-y-6 lg:space-y-10 px-4">
                    <h1
                        style={{ fontFamily: "Poppins, sans-serif" }}
                        className="text-xl sm:text-2xl md:text-4xl lg:text-6xl font-normal space-y-4"
                    >
                       
                        <h1> Building Robust Bridges for</h1> <h1> Tomorrow</h1>
                    </h1>
                    <p className="text-sm sm:text-base md:text-lg lg:text-xl">
                    Our expertise in bridge construction delivers safe, resilient, and innovative structures that connect communities while meeting the highest engineering standards.
                    </p>
                </div>
            </div>

        </React.Fragment>
    )
}

export default HeroSection2